<template>
    <div v-if="showModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <h2>{{ title }}</h2>
          <button @click="closeModal"><span class="ti-close"></span></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  
<template>
  <div v-if="showModal" class="modal-overlay">
    <div class="modal">
      <div class="modal-header">
        <h2>{{ title }}</h2>
        <button @click="closeModal"><span class="ti-close"></span></button>
      </div>
      <div class="modal-body" ref="modalBody">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    title: String,
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // 📱 Only run if screen width <= 767px (mobile)
          if (window.innerWidth <= 767) {
            if (this.$refs.modalBody) {
              this.$refs.modalBody.scrollTop = 0
            }
            window.scrollTo(0, 0) // scroll page itself to top
          }
        })
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    }
  }
}
</script>

  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .modal {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    width: 600px;
    display: block !important;
    top: 5%;
    left: auto!important;
    height: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
  }
  
  .modal-header button {
    background: none;
    border: none;
    cursor: pointer;
    color: #333;
    font-weight: bold;
  }
  </style>